import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import Plants from './components/Plants.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: Plants },
  ],
})

const app = createApp(App)
app.use(router)
app.mount('#app')
